import { Box, Stack, Typography } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { PaymentMethod } from '@/packages/courses/pages/checkout/components/payment-method';
import { type PaymentMethodFormData } from '@/packages/courses/pages/checkout/schema';

export const PaymentMethodStep = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<PaymentMethodFormData>();

  return (
    <Box>
      <Typography variant="h1" color="primary.dark" mb={4}>
        Escolha como pagar
      </Typography>
      <Controller
        name="paymentMethod"
        control={control}
        render={({ field }) => (
          <Stack spacing={2}>
            <PaymentMethod
              selectedMethod={field.value || ''}
              onSelectMethod={field.onChange}
            />
          </Stack>
        )}
      />
      {errors.paymentMethod && (
        <Typography color="error" mt={1}>
          {errors.paymentMethod?.message}
        </Typography>
      )}
    </Box>
  );
};
